import { useState } from "react";
import ProfilePicture from "./ProfilePicture";
import ProfileInfo from "./ProfileInfo";
import PagePermissionsContainer from "../containers/PagePermissionsContainer";
import OrganizationFormContainer from "../containers/OrganizationFormContainer";

function UserDetailsForm({ user = {}, userUpdate, isLoading, isOwner }) {
  const [updatingField, setUpdatingField] = useState("");

  const profile = user?.profilePicId?.url;

  return (
    <div className="md:w-3/5">
      <div className="font-bold text-gray-700 my-2 mb-6 text-2xl font-bold">
        Profile
      </div>

      <ProfilePicture
        profile={profile}
        userUpdate={userUpdate}
        setUpdatingField={setUpdatingField}
        isLoading={updatingField === "profilePic" && isLoading}
      />

      <ProfileInfo
        user={user}
        userUpdate={userUpdate}
        setUpdatingField={setUpdatingField}
        isLoading={updatingField === "userName" && isLoading}
      />

      {isOwner ? (
        <div className="mt-16">
          <OrganizationFormContainer />
        </div>
      ) : null}

      <div className="mt-16">
        <PagePermissionsContainer />
      </div>
    </div>
  );
}

export default UserDetailsForm;
